export default __webpack_public_path__ + "static/audit_report-89967b1290db095d7275ce21e8aa5d44.pdf";